import { useNavigate } from 'react-router-dom';
import styles from './DetailHeader.module.css';
// useNavigate는 제작사 링크에서 사용

const STATUS_STYLE = {
  '지원완료': { bg: '#EEF9FB', color: '#25B0C3' },
  '1차통과':  { bg: '#D6F2F6', color: '#1A8999' },
  '2차통과':  { bg: '#C2ECF2', color: '#157A8A' },
  '3차통과':  { bg: '#A8E3EC', color: '#0F6A78' },
  '4차통과':  { bg: '#8ED9E5', color: '#0A5A66' },
  '합격':     { bg: '#E8F5E9', color: '#2E7D32' },
  '불합격':   { bg: '#FFEBEE', color: '#C62828' },
  '취소':     { bg: '#F3F3F5', color: '#888896' },
};

const CATEGORY_EMOJI = {
  '드라마': '📺',
  '영화':   '🎬',
  '웹드라마': '💻',
  '뮤지컬': '🎭',
  '광고':   '📢',
  '영상':   '🎥',
};

function getCategoryEmoji(category) {
  if (!category) return '📷';
  for (const [key, emoji] of Object.entries(CATEGORY_EMOJI)) {
    if (category.includes(key)) return emoji;
  }
  return '📷';
}

export default function DetailHeader({ app }) {
  const navigate = useNavigate();
  const badge = STATUS_STYLE[app.status] || { bg: '#EEF9FB', color: '#25B0C3' };
  const emoji = getCategoryEmoji(app.category);

  return (
    <div className={styles.header}>
      {/* 왼쪽: 배지 + 제목 + 메타 */}
      <div className={styles.left}>
        <span
          className={styles.badge}
          style={{ background: badge.bg, color: badge.color }}
        >
          {app.status}
        </span>
        <h1 className={styles.title}>
          <span className={styles.titleEmoji}>{emoji}</span>
          {app.title}
        </h1>
        <div className={styles.metaRow}>
          {app.companyId ? (
            <button
              className={styles.metaCompanyBtn}
              onClick={() => navigate(`/producer/${app.companyId}`)}
            >
              {app.company}
            </button>
          ) : (
            <span className={styles.metaCompanyText}>{app.company}</span>
          )}
          <span className={styles.metaSep}>지원일: {app.date}</span>
        </div>
      </div>

    </div>
  );
}
